import abilities from '../data/abilities.json';
import achievements from '../data/achievements.json';
import banners from '../data/banners.json';
import classes from '../data/classes.json';
import enemies from '../data/enemies.json';
import game from '../data/game.json';
import items from '../data/items.json';
import races from '../data/races.json';
import rarities from '../data/rarities.json';
import relics from '../data/relics.json';
import talents from '../data/talents.json';
import upgrades from '../data/upgrades.json';
import zones from '../data/zones.json';
import type { RawContent } from './load';

export const rawContent: RawContent = { game, classes, abilities, talents, enemies, items, rarities, zones, upgrades, races, relics, achievements, banners };
